import { cn } from '@/lib/utils'
import { Typo3SectionSpotSanityContentTable } from '@/types/typo3'
import {
  Base,
  Container,
  Richtext,
  Section,
  SectionHeader
} from '@/ui/components'
import { memo } from 'react'
import ScrollBar from './Components/Scrollbar'
import Table from './Components/Table'

interface Props {
  data: Typo3SectionSpotSanityContentTable
}

const SpotSanityContentTable = ({ data }: Props) => {
  const c = data.content
  const layout = c?.table?.layout
  const table = c?.table
  const headerPosition = table?.headerPosition

  const rows = headerPosition === 'top' ? table?.rows?.slice(1) : table?.rows

  return (
    <Section data={data} className="s-spotsanity-content-table py-xl">
      <SectionHeader titleLayout={c?.titleLayout} title={c?.title} />

      <Base anim="fade-in" className={cn('relative')}>
        <ScrollBar data={data}>
          <Table
            headerPosition={headerPosition}
            table={table}
            layout={layout}
            rows={rows}
          />
        </ScrollBar>
        {c?.notes && (
          <Container
            anim="fade-in"
            className={'pt-lg textstyle-sm-regular text-neutral-400'}
          >
            <Richtext text={c?.notes} />
          </Container>
        )}
      </Base>
    </Section>
  )
}

export default memo(SpotSanityContentTable)
